import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-no-wrap" }
const _hoisted_2 = { class: "w-100 mr-2" }

const logo_img = 'img/logo.png';

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      color: "#A5E4EE",
      theme: "dark"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_avatar, {
            class: "ma-3",
            size: "75",
            rounded: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: logo_img,
                class: "rounded-circle"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_text_field, {
              "bg-color": "white",
              density: "compact",
              class: "search-input mt-7",
              label: "Search",
              "prepend-inner-icon": "fa-search"
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})